import { render, staticRenderFns } from "./hero_items.vue?vue&type=template&id=cfdfd974&scoped=true"
import script from "./hero_items.vue?vue&type=script&lang=js"
export * from "./hero_items.vue?vue&type=script&lang=js"
import style0 from "./hero_items.vue?vue&type=style&index=0&id=cfdfd974&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdfd974",
  null
  
)

export default component.exports